import Reveal from '@/components/feature/Reveal';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Atmospheric%20premium%20American%20craft%20brewery%20interior%20with%20polished%20copper%20brewing%20kettles%20and%20stainless%20steel%20tanks%2C%20warm%20golden%20amber%20lighting%2C%20dark%20moody%20charcoal%20tones%2C%20subtle%20steam%20and%20hops%20accents%2C%20cinematic%20editorial%20photography%2C%20rich%20shadows%2C%20sophisticated%20artisanal%20craft%20beer%20aesthetic%2C%20high%20detail&width=1920&height=1080&seq=brewery-hero-01&orientation=landscape"
          alt="Premium craft brewery interior with copper brewing kettles and warm amber lighting"
          title="23 Bottles of Beer LLC — California craft brewing"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 py-28 text-center">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.4em] uppercase text-background-100/90 mb-6">
            Independent Craft Brewing · California
          </p>
        </Reveal>
        <Reveal delay={100}>
          <h1 className="font-heading font-semibold text-5xl md:text-7xl lg:text-8xl leading-[0.95] text-background-50">
            Crafted with<br className="hidden md:block" /> Character.
          </h1>
        </Reveal>
        <Reveal delay={200}>
          <p className="font-heading text-xl md:text-2xl text-primary-300 mt-6 tracking-wide">
            23 Bottles of Beer LLC
          </p>
        </Reveal>
        <Reveal delay={300}>
          <p className="max-w-2xl mx-auto mt-6 text-base md:text-lg text-background-100/85 leading-relaxed">
            An independent California craft brewing business built around quality,
            craftsmanship, and a passion for great beer.
          </p>
        </Reveal>
        <Reveal delay={400}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-8 py-4 text-base font-semibold text-background-50 hover:bg-primary-600 active:bg-primary-700 transition-colors"
            >
              Get in Touch
            </a>
            <a
              href="#craft"
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md border border-background-100/50 px-8 py-4 text-base font-medium text-background-50 hover:bg-background-50/10 active:bg-background-50/20 transition-colors"
            >
              Discover Our Craft
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}